import { useLazyQuery } from '@apollo/react-hooks';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { shouldHandleTheError } from '../../common/utils/partial-data/index.tsx';
import { JIRA_SETTINGS_QUERY } from './gql.tsx';
import type { JiraBusinessSettingsReturn, JiraSettings } from './types.tsx';

export const useJiraSettings = (): JiraBusinessSettingsReturn => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const [getProjectData, { data, loading, error }] = useLazyQuery<JiraSettings, Record<any, any>>(
		JIRA_SETTINGS_QUERY,
		{
			onError: (apolloError) => {
				if (
					!shouldHandleTheError(apolloError) &&
					fg('jira_list_-_support_partial_failures_services')
				) {
					return;
				}

				fireErrorAnalytics({
					meta: {
						id: 'jiraSettingsQuery',
						packageName: 'jiraBusinessList',
						teamName: 'keystone',
					},
					attributes: {
						message: 'Failed to fetch jira settings in list view',
					},
					error: apolloError,
					sendToPrivacyUnsafeSplunk: true,
				});
			},
		},
	);

	return {
		error,
		loading,
		data,
		getProjectData,
	};
};
